import React from "react";

class ChartTooltip extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { style } = this.props;
    return (
      <div
        role="tooltip"
        className="animate__animated animate__fadeInUp"
        style={style}
      ></div>
    );
  }
}

export default ChartTooltip;
